import { format, isValid, parse, parseISO } from 'date-fns';

import type { ISODate } from './types';

export const DATE_FORMATS = [
  'dd/MM/yyyy',
  'dd/MM/yy',
  'dd-MM-yyyy',
  'dd-MM-yy',
  'ddMMyyyy',
  'ddMMyy',
] as const;

export const isoDateToDate = (date: ISODate) => {
  return parseISO(date);
};

export const dateToString = (date: Date | ISODate) => {
  if (typeof date === 'string') {
    return format(isoDateToDate(date), 'dd/MM/yyyy');
  }

  return format(date as Date, 'dd/MM/yyyy');
};

/**
 * Accepts the following dates:
 * 01/01/2023
 * 01-01-2023
 * 01012023
 */
export const stringToDate = (value: string) => {
  let date = parse(value, 'dd/MM/yyyy', new Date());
  if (!isValid(date)) {
    date = parse(value, 'dd-MM-yyyy', new Date());
  }
  if (!isValid(date)) {
    date = parse(value, 'ddMMyyyy', new Date());
  }

  return date;
};

export const parseDateWithFormats = (
  value: string,
  formats: readonly string[]
): Date | undefined => {
  for (const format of formats) {
    const parsed = parse(value, format, new Date());
    if (isValid(parsed) && parsed.getFullYear() >= 1000) {
      return parsed;
    }
  }
  return undefined;
};
